import Swiper from "swiper";
import {
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
} from "swiper/modules";

Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow]);

// Basic Carousel
var swiper = new Swiper(".basic-slider", {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  },
});

// Basic Carousel
var swiper = new Swiper(".basic-carousel", {
  slidesPerView: 2,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
      navigation: {
        enabled: true,
      },
    },
    992: {
      slidesPerView: 5,
      navigation: {
        enabled: true,
      },
    },
  },
});

// Basic Carousel
var swiper = new Swiper(".hero-slider", {
  loop: true,
  autoplay: {
    delay: 7000,
    pauseOnMouseEnter: true,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  },
});

// Member Stories — coverflow carousel (per-instance, scoped nav/pagination)
document.querySelectorAll(".member-stories-carousel").forEach((el) => {
  if (el.swiper) {
    return;
  }

  const count = parseInt(el.dataset.storiesCount || "0", 10);
  const section = el.closest(".member-stories") || el;

  const swiper = new Swiper(el, {
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "auto",
    initialSlide: Math.floor(count / 2),
    rewind: count > 1,
    spaceBetween: 8,
    speed: 500,
    grabCursor: count > 1,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      scale: 0.75,
      slideShadows: false,
    },
    navigation: {
      nextEl: section.querySelector(".member-stories__arrow--next"),
      prevEl: section.querySelector(".member-stories__arrow--prev"),
    },
    pagination: {
      el: el.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      992: {
        spaceBetween: 16,
      },
    },
  });

  // Posters load asynchronously; recalc slide sizes once each finishes so the coverflow doesn't collapse.
  el.querySelectorAll(".member-stories__poster").forEach((img) => {
    if (!img.complete) {
      img.addEventListener("load", () => swiper.update(), { once: true });
    }
  });
});

// Load and autoplay a stories lightbox video when it opens.
document.addEventListener("show.bs.modal", (event) => {
  if (!event.target.classList.contains("member-stories-video-modal")) {
    return;
  }

  const iframe = event.target.querySelector("iframe");
  if (iframe && iframe.dataset.src) {
    const url = iframe.dataset.src;
    const separator = url.indexOf("?") === -1 ? "?" : "&";
    iframe.setAttribute("src", url + separator + "autoplay=1");
  }

  const video = event.target.querySelector("video");
  if (video) {
    const playback = video.play();
    if (playback && typeof playback.catch === "function") {
      playback.catch(() => {});
    }
  }
});

// Stop video/iframe playback when a stories lightbox closes.
document.addEventListener("hidden.bs.modal", (event) => {
  if (!event.target.classList.contains("member-stories-video-modal")) {
    return;
  }

  const video = event.target.querySelector("video");
  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  const iframe = event.target.querySelector("iframe");
  if (iframe) {
    const src = iframe.getAttribute("src");
    if (src) {
      // Re-store without the autoplay flag we appended on open, so reopens stay clean.
      iframe.dataset.src = src.replace(/[?&]autoplay=1/, "");
      iframe.setAttribute("src", "");
    }
  }
});
